import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.QIS_SERVER_PREFIX}/farmar`;
const endpoints = {
    validateMobile: () => `${RESOURCE_ENDPOINT}/check-mobile`,
    validateNid: () => `${RESOURCE_ENDPOINT}/validateNid`,
    checkIsDuplicateFarmer: () => `${RESOURCE_ENDPOINT}/checkIsDuplicateFarmer`,
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    create: () => `${RESOURCE_ENDPOINT}`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
    searchFarmerByMobileOrNid: () => `${RESOURCE_ENDPOINT}/searchFarmerByMobileOrNid`,
    listAll: () => `${RESOURCE_ENDPOINT}/list-all`,
    citizenSearch: () => `${RESOURCE_ENDPOINT}/citizen-search`,
    citizenVerify: () => `${RESOURCE_ENDPOINT}/citizen-verify`,
    citizenLink: () => `${RESOURCE_ENDPOINT}/citizen-link`,
};

export default class FarmarApi {
    public validateMobile = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.validateMobile();

        return HttpService.get(url, params, headers);
    };
    public validateNid = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.validateNid();

        return HttpService.get(url, params, headers);
    };

    public checkIsDuplicateFarmer = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.checkIsDuplicateFarmer();
        return HttpService.post(url, payload, params, headers);
    };

    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();

        return HttpService.get(url, params, headers);
    };

    public getById = (id: any): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url);
    };

    public create = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    };

    public update = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    };

    public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    };

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    };

    public bulk = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    };

    public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdown();
        return HttpService.get(url, params, headers);
    };

    public listAll = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.listAll();
        return HttpService.get(url, params, headers);
    };

    public searchFarmerByMobileOrNid = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.searchFarmerByMobileOrNid();
        return HttpService.get(url, params, headers);
    };

    // Citizen–farmer linking: masked matches by normalized mobile and/or NID
    public citizenSearch = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.citizenSearch();
        return HttpService.get(url, params, headers);
    };

    // { farmer_id, nid } → { verified, link_status, farmer }
    public citizenVerify = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.citizenVerify();
        return HttpService.post(url, payload, params, headers);
    };

    // { farmer_id, nid } → linked farmer record
    public citizenLink = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.citizenLink();
        return HttpService.post(url, payload, params, headers);
    };
}
